module.exports = __webpack_public_path__ + "img/1.e17c8680.png";